import { render, staticRenderFns } from "./HeaderSign.vue?vue&type=template&id=b6406990&scoped=true&"
import script from "./HeaderSign.vue?vue&type=script&lang=js&"
export * from "./HeaderSign.vue?vue&type=script&lang=js&"
import style0 from "./HeaderSign.vue?vue&type=style&index=0&id=b6406990&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b6406990",
  null
  
)

export default component.exports